import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../../Admin1/Pages/admin1.css";
import axios from "axios";
import Loader from "../../../safreeimg/loader.gif";
import addbtn from "../../../safreeimg/addbtn.png";

const CouponDiscount = () => {
  const [coupons, setCoupons] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const rowsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          setError("No authentication token found");
          setLoading(false);
          return;
        }

        const response = await axios.get(
          "https://api.safree.org/api-v2022/superAdmin/auth/v1/all/coupons",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.success && Array.isArray(response.data.data)) {
          setCoupons(response.data.data);
        } else {
          setError("Failed to fetch coupons");
        }
      } catch (err) {
        console.error("Error fetching coupons:", err);
        setError("An error occurred while fetching coupons: " + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Toggle the active status
  const toggleCouponStatus = async (index, coupon, currentStatus) => {
    try {
      const token = localStorage.getItem("token");
      const newStatus = !currentStatus;
      const couponId = coupon.couponId; // ✅ Ensure correct property

      if (!couponId) {
        console.error("❌ Error: Coupon ID is undefined for coupon:", coupon);
        return;
      }

      const requestBody = {
        couponId: couponId, // ✅ Send JSON format
        status: newStatus,
      };

      console.log("📤 Sending JSON Data:", requestBody);

      const response = await axios.post(
        "https://api.safree.org/api-v2022/superAdmin/auth/v1/coupon/update/status",
        requestBody, // ✅ Direct JSON object
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // ✅ Ensure JSON header
          },
        }
      );

      console.log("✅ API Response:", response.data);

      if (response.data.success) {
        setCoupons((prevCoupons) =>
          prevCoupons.map((c, i) =>
            i === index ? { ...c, isActive: newStatus } : c
          )
        );
      }
    } catch (error) {
      console.error("❌ Error updating coupon status:", error);
    }
  };


  const totalPages = Math.ceil(coupons.length / rowsPerPage);
  const currentRows = coupons.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (direction) => {
    if (direction === "prev" && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
    if (direction === "next" && currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const getPageNumbers = () => {
    const maxPageNumbersToShow = 5;
    const startPage = Math.max(
      1,
      currentPage - Math.floor(maxPageNumbersToShow / 2)
    );
    const endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);
    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  };

  if (loading) return <div className="loading"><img src={Loader} alt="Loading..." /></div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="container user-management">
      <div className="row header">
        <div className="col-md-6">
          <p className="sub-heading">Coupon & Discount Management</p>
        </div>
        <div className="col-md-6 hedrcol2">
          <h3 style={{ cursor: "pointer" }}>
            <Link to="/admin1/couponDiscount/newCoupon">Create New Coupon <img src={addbtn} alt="Add" /></Link>
          </h3>
        </div>
      </div>

      <div className="table-container">
        <table className="styled-table">
          <thead>
            <tr>
              <th>S. No</th>
              <th>Coupon Code</th>
              <th>Discount %</th>
              <th>Description</th>
              <th>Status</th>
              <th>Coupon</th>
            </tr>
          </thead>
          <tbody>
            {currentRows.map((coupon, index) => (
              <tr key={index}>
                <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                <td>{coupon.couponCode || "N/A"}</td>
                <td>{coupon.offerPercentage ? `${coupon.offerPercentage}%` : "N/A"}</td>
                <td>{coupon.description || "N/A"}</td>
                <td>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={coupon.isActive}
                      onChange={() => toggleCouponStatus(index, coupon, coupon.isActive)}
                    />
                    <span className="slider round"></span>
                  </label>
                </td>
                <td>
                  <button
                    className="btn btn-view"
                    onClick={() => navigate(`../couponDiscount/couponSend/#${coupon.couponId}`)}
                    disabled={!coupon.isActive}
                  >
                    Send
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="pagination-container">
          <button
            className="pagination-btn"
            onClick={() => handlePageChange("prev")}
            disabled={currentPage === 1}
          >
            &laquo; Prev
          </button>
          {getPageNumbers().map((page) => (
            <button
              key={page}
              className={`pagination-btn ${currentPage === page ? "active" : ""}`}
              onClick={() => setCurrentPage(page)}
            >
              {page}
            </button>
          ))}
          <button
            className="pagination-btn"
            onClick={() => handlePageChange("next")}
            disabled={currentPage === totalPages}
          >
            Next &raquo;
          </button>
        </div>
      </div>
    </div>
  );
};

export default CouponDiscount;